import React from 'react';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {}

const Screen5: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.Screen5');

    return (
        <div className={`${style.comp} Screen5 GtmModuleData-section`} id="Screen5" data-section-id="Screen5">
            <EcoSection
                title={t.rich('title', {
                    s: (v: string) => <span>{v}</span>,
                })}
                desc={t.rich('desc', {
                    t: (i: string) => (
                        <span className="sub-desc" style={{ fontSize: '0.7em' }}>
                            {i}
                        </span>
                    ),
                })}
            />
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1748414114324/screen5.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1748414114515/screen5-h5.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1748414114515/screen5-h5.jpg"
            />
        </div>
    );
};
export default Screen5;
